import React from 'react';
import { useTranslation } from 'react-i18next';
//components
import Loader from '../Loader';
//assets
import { BucketIcon } from 'assets/icons';
//styles
import { DeleteBtnWrapper, DeleteBtnLabel } from './DeleteButton.styled';

interface IDeleteButton {
  label: string;
  onClick: () => void;
  isFetching: boolean;
}

export const DeleteButton = ({ label, onClick, isFetching }: IDeleteButton) => {
  const { t } = useTranslation();

  return (
    <DeleteBtnWrapper onClick={onClick} type="button">
      {!isFetching ? <BucketIcon width={22} height={22} /> : <Loader />}
      <DeleteBtnLabel>{t(label)}</DeleteBtnLabel>
    </DeleteBtnWrapper>
  );
};
